import React, {useContext, useEffect, useState} from "react";
import TableAntD from "@common/TableAntD";
import createTableAntDHeaderFilter from "@common/TableAntDHeaderFilterColumn";
import axios from "@common/axios";
import Button from "@common/Button";
import {getSittingsText} from "./StudentTestAssignments";
import {BrandContext} from "@context/BrandContext";
import {UserContext} from "@context/UserContext";
import CircularLoader from "@common/CircularLoader";
import useCurrentShortcut from "@hooks/useCurrentShortcut";
import {Tag} from 'antd';
import {isCancel} from "axios";

const handleOpenTestAssignmentPDF = (record)=>{
    submitTest(record.testAssignmentId);
}

const handleViewDiagnosticAdaptiveLessonResults = (record)=>{
    if(record.testResultId) {
        openUserDiagnosticTestLessonResultsDialog(record.testResultId);
    }
}

const TEST_TYPE_ARR = [
    {text: 'Exam', value: 'Exam'},
    {text: 'Test', value: 'Test'},
    {text: 'Diagnostic', value: 'Diagnostic'}
];
const TEST_RESULT_ARR = [
    {text:'Abandoned', value:'ABANDONED'},
    {text:'Completed', value:'COMPLETED'},
    {text:'Expired', value:'EXPIRED'},
    {text:'Started', value:'STARTED'},
    {text:'Timed-out', value:'TIMED_OUT'}
]

const ClosedTestAssignments = (props) =>{
    const {title, defaultTablePageSize = 6, handleViewTestResult} = props;
    const {loadShortcutByUrl} = useCurrentShortcut(),
    [addStyle, setAddStyle] = useState(false);

    const handleViewDiagnosticFeedbackReport = (record)=>{
        if(record.testResultId) {
            loadShortcutByUrl('/web/ui/view/diagnostics/studentReports', undefined, record.testResultId);
        }
    }

    const closed_cols = {
            name:{title:'Name', key:'name', dataIndex:'name',
                sorter: (a,b)=>{
                    return a.testName.localeCompare(b.testName);
                },
                sortDirections: ['ascend', 'descend']
            },
            type: createTableAntDHeaderFilter('Type', 'type', 'type', TEST_TYPE_ARR, 'type'),
            // message:{title:'Message', key:'message', dataIndex:'message'},
            assigned:{title:'Assigned', key:'assigned', dataIndex:'assigned',
                sorter: (a, b) => {
                    return a.assignedDate - b.assignedDate;
                },
                sortDirections: ['ascend', 'descend']
                },
            started:{title:'Started', key:'started', dataIndex:'started',
                sorter: (a, b) => {
                    return a.startDate - b.startDate;
                },
                sortDirections: ['ascend', 'descend']
                },
            completed:{title:'Completed', key:'completed', dataIndex:'completed',
                sorter: (a, b) => {
                      // Handle undefined dates
                  if (a.completeDate === undefined && b.completeDate === undefined){
                      return 0;
                  }
                  if (a.completeDate === undefined){
                      return -1;
                  }
                  if (b.completeDate === undefined) {
                      return 1;
                  }

                  return a.completeDate - b.completeDate;
                },
                sortDirections: ['ascend', 'descend']
            },
            result: createTableAntDHeaderFilter('Result', 'result', 'result', TEST_RESULT_ARR, 'testAssignmentStatus'),
            view:{title:'View', key:'view', dataIndex:'view',
                render: (_, record) => {

                let returnComponent;
                    if(!record.autoMark){
                        returnComponent =  (
                            <Button onClick={()=>{handleOpenTestAssignmentPDF(record)}}>
                                PDF
                            </Button>
                        )
                    }else if(!record.open && (record.testAssignmentStatus === 'STARTED' || record.testAssignmentStatus === 'ABANDONED' || record.testAssignmentStatus === 'TIMED_OUT')){
                        returnComponent =(
                            <Button onClick={()=>{handleSubmitTestAssignmentResults(record)}}>
                                Submit
                            </Button>)
                    }else if((record.expired || record.revision || record.noExpiry) && record.hasStartDate){
                        if(!record.diagnosticTest && record.showResult) {
                            returnComponent = (<Button onClick={()=>{handleViewTestResult(record)}}>
                                Results
                            </Button>)
                        }
                        if(record.diagnosticTest && record.adaptive){
                            returnComponent = (<div className={'flexColumn flexCentre smallGap'}>
                                <Button onClick={()=>{handleViewDiagnosticAdaptiveLessonResults(record)}}>
                                    Feedback
                                </Button>
                                {record.showResult &&
                                    <Button onClick={()=>{handleViewTestResult(record)}}>
                                        Results
                                    </Button>
                                }
                            </div>)
                        }else if(record.diagnosticTest && !record.adaptive){
                            if(record.feedbackAssigned) {
                                returnComponent = (<div className={'flexColumn flexCentre smallGap'}>
                                    <Button onClick={() => {
                                        handleViewDiagnosticFeedbackReport(record)
                                    }}>
                                        Feedback
                                    </Button>
                                    {record.showResult &&
                                        <Button onClick={() => {
                                            handleViewTestResult(record)
                                        }}>
                                            Results
                                        </Button>
                                    }
                                </div>)
                            } else if(record.showResult) {
                                returnComponent =  <Button onClick={() => {
                                    handleViewTestResult(record)
                                }}>
                                    Results
                                </Button>
                            }else{
                                returnComponent = <p>N/A</p>
                            }
                        }
                    }else{
                        returnComponent = <>N/A</>
                    }
                    return <div className={'flexCentre'}>{returnComponent}</div>
                }}
        },
        columnData = Object.values(closed_cols);


    const [data, setData] = useState([]),
        [reload, setReload] = useState(null),

        brandConfig = useContext(BrandContext),
        {user} = useContext(UserContext);

    const modifyDataForTable = (rawData)=>{
        return rawData.map((row)=>{
            return {
                key:row.testAssignmentId,
                ...row,
                [closed_cols.name.key]: <div><p style={{whiteSpace:'nowrap'}}>{row.testName} <Tag className="ch-tag-secondary">{getSittingsText(row, brandConfig.assessmentTestName, brandConfig.revisionTestName)}</Tag></p>
                    <p>
                        {row.testAssignmentStatus === 'COMPLETED' && <>
                        {(row.diagnosticTest && !row.adaptive) ?
                            (<>
                            {row.feedbackAssigned ?
                                (<a href={"/web/ui/view/diagnostics/studentReports#"+row.testResultId}>Feedback available</a>) :
                                (<span className="ch-dashboard-warning-text">Waiting for teacher feedback</span>)}
                            </>) :
                            (<>
                            {(!row.expired && !row.revision && !row.noExpiry) &&
                                <span className="ch-dashboard-warning-text">Test results available in {row.timeToExpiry}</span>}
                            </> )
                             }
                        </>}
                    </p>
                </div>,
                [closed_cols.type.key]: row.testTypeDescription,
                [closed_cols.assigned.key]: <div className="flexColumn flexAlignCentre"><span className="flexCentre">{user.dateFormat.format((row.dateAssigned))}</span><span className="flexCentre">{user.timeFormat.format((row.dateAssigned))}</span></div>,
                [closed_cols.started.key]: <div className="flexColumn flexAlignCentre"><span className="flexCentre">{user.dateFormat.format((row.startDate))}</span><span className="flexCentre">{user.timeFormat.format((row.startDate))}</span></div>,
                [closed_cols.completed.key]: row.completeDate ? (<div className="flexColumn flexAlignCentre"><span className="flexCentre">{user.dateFormat.format((row.completeDate))}</span><span className="flexCentre">{user.timeFormat.format((row.completeDate))}</span></div>) : (<div></div>),
                [closed_cols.result.key]: <div className="flexColumn flexAlignCentre">
                    <div>{row.testAssignmentStatusDescription}</div>
                    {row.completed &&
                        <div>{row.adaptive ? row.totalCorrect : row.mark}/{row.adaptive ? row.total : row.maxMark}</div>
                    }
                </div>,
                [closed_cols.view.key]: row.testName
            }
        })
    }

    const handleSubmitTestAssignmentResults = (record)=>{
        if(record.testAssignmentId) {
            axios.post("/controlCentre/submitTest.action", null, {params: {testAssignmentId: record.testAssignmentId}})
                .then((response)=>{
                        if(response.data.success) {
                            displayToastMessage("Test submitted", 'Your test has been submitted', 'success', 300);
                            setReload(new Date().getTime());
                        } else {
                            displayToastMessage("Error", 'There was an error submitting your test. Please try again.', 'error', 300);
                        }
                }).catch( (error)=> {
                displayToastMessage("Error", 'There was an error submitting your test. Please try again.'+error, 'error', 300);
            });
        }
    }

    const searchClosedTestAssignments = (params, handleTableData, handlePagingData, abortController, callback)=>{
        axios.get('/web/ui/test/studentTestResults',{params:params, signal:abortController.signal})
            .then(response => {
                if (response && response.data) {
                    handleTableData(modifyDataForTable(response.data.currPageContents));
                    const {currPage, pageSize, totalResults} = response.data;
                    handlePagingData({currPage, pageSize, totalResults});
                    setAddStyle(totalResults > pageSize);
                }
            }).catch((error) => {
            //throws error if not purposefully cancelled
            if (!isCancel(error)) {
                console.error('Error loading student test assignments: ', error);
                displayToastMessage('', 'Error loading test assignments.', 'error', null,10000);
                throw error;
            }
        }).finally(()=>{
            abortController = null;
        });
    }

    return (
        <>
            {title && <h2 className={'padding--m'}>{title}</h2>}
            <TableAntD
                pagingDependencies={[]}
                reload={reload}
                pagingData={{fetchFunction:searchClosedTestAssignments, params:{pageSize:defaultTablePageSize, currentPage:1}}}
                noDataMessage={<p className={'padding--m flexJustifyStart'}>{'No ' + brandConfig.assessmentTestName + ' results to show.'}</p>}
                columnData={columnData}
                dynamicWidth={true}
            />
        </>
    )

}
export default ClosedTestAssignments;
